const Server = require('helper/server');

class EsClient {
  constructor () {
    this.resetQuery();
    this.siteId = $('[name=siteId]').val();
  }

  resetQuery () {
    this.query = {
      bool: {
        must: [],
        adjust_pure_negative: true,
        boost: 1.0,
        should: []
      }
    };
  }

  buildTermQuery (key, value, boost = 1.0) {
    this.query.bool.must.push({
      term: { [key]: { value, boost } }
    });
  }

  buildRangeQuery (key, from, to, boost = 1.0) {
    this.query.bool.must.push({
      range: {
        [key]: { from, to, include_lower: true, include_upper: true, boost }
      }
    });
  }

  buildWildcardQuery (key, value, boost = 1.0) {
    this.query.bool.must.push({
      wildcard: { [key]: { wildcard: value, boost } }
    });
  }

  buildSimpleWildcardQuery (key, value) {
    this.query.bool.must.push({
      match_phrase: { [key]: value }
    });
  }

  buildMatchQuery (key, value, boost = 1.0) {
    this.query.bool.must.push({
      match: {
        [key]: {
          query: value,
          operator: 'OR',
          prefix_length: 0,
          max_expansions: 50,
          fuzzy_transpositions: true,
          lenient: false,
          zero_terms_query: 'NONE',
          auto_generate_synonyms_phrase_query: true,
          boost
        }
      }
    });
  }

  buildMultiMatchQuery (query, fields = [], boost = 1.0) {
    this.query.bool.must.push({
      multi_match: {
        query,
        fields,
        type: 'best_fields',
        operator: 'OR',
        slop: 0,
        prefix_length: 0,
        max_expansions: 50,
        zero_terms_query: 'NONE',
        auto_generate_synonyms_phrase_query: true,
        fuzzy_transpositions: true,
        boost
      }
    });
  }

  buildShouldQuery (key, value) {
    let arr = [];
    if (typeof value == 'string' && value.includes(',')) {
      value = value.split(',');
    }
    if (value instanceof Array) {
      arr = value.map(item => ({
        match_phrase: {
          [key]: item
        }
      }));
    } else {
      arr = [
        {
          match_phrase: {
            [key]: value
          }
        }
      ];
    }
    this.query.bool.must.push({
      bool: {
        should: arr
      }
    });
  }

  buildAdvanceQuery (key, value, isAll = true) {
    let arr = [];
    // debugger;
    if (typeof value == 'string' && value.includes(',')) {
      value = value.split(',');
    }
    if (value instanceof Array) {
      arr = value.map(item => ({
        wildcard: {
          [key]: isAll ? (item && item.toString().slice(0, 4) + '*' || '*') : item
        }
      }));
    } else {
      arr = [
        {
          wildcard: {
            [key]: value
          }
        }
      ];
    }
    this.query.bool.must.push({
      bool: {
        should: arr
      }
    });
  }

  // 用于全站的搜索
  searchArticle ({ siteId = this.siteId, pageNo, pageSize, keyword, begin, end, firstCode, secondCode, districtCode }) {
    this.resetQuery();
    this.buildTermQuery('siteId', siteId);
    keyword && this.buildMultiMatchQuery(keyword, ['content^1.0', 'title^2.0']);
    districtCode && this.buildShouldQuery('districtCode', districtCode);
    begin && end && this.buildRangeQuery('publishDate', begin, end);
    firstCode && this.buildTermQuery('firstCode', firstCode.toLowerCase());
    secondCode && this.buildTermQuery('secondCode', secondCode.toLowerCase());
    return this.search({
      from: (pageNo - 1) * pageSize,
      size: pageSize,
      query: this.query,
      highlight: {
        pre_tags: ['<em>'],
        post_tags: ['</em>'],
        number_of_fragments: 2,
        fields: {
          title: { fragment_size: 200 },
          content: { fragment_size: 100 }
        }
      }
    });
  }

  // 用于二级页的搜索(文章和公告)
  searchArticleByKeyWord ({
    siteId = this.siteId,
    pageNo,
    pageSize,
    keyword,
    code,
    begin,
    end,
    projectName,
    projectCode,
    gpCatalogName, // 采购分类
    districtCode,
    wildcardDistrictCode, // 模糊匹配的区划码
    procurementMethodCode,
    isAll // 高级搜索时是否模糊匹配
  }) {
    this.resetQuery();
    this.buildTermQuery('siteId', siteId);
    districtCode && this.buildAdvanceQuery('districtCode', districtCode, isAll);
    keyword && this.buildMultiMatchQuery(keyword, ['title^1.0']);
    begin && end && this.buildRangeQuery('publishDate', begin, end);
    code && this.buildWildcardQuery('path', `*6${code.toLowerCase()}6*`);
    wildcardDistrictCode && this.buildWildcardQuery('districtCode', wildcardDistrictCode);
    projectName && this.buildWildcardQuery('projectName', `*${projectName}*`);
    projectCode && this.buildWildcardQuery('projectCode', `*${projectCode}*`);
    gpCatalogName && this.buildWildcardQuery('gpCatalogName', `*${gpCatalogName}*`);


    procurementMethodCode && this.buildTermQuery('procurementMethodCode', procurementMethodCode);
    const obj = {
      from: (pageNo - 1) * pageSize,
      size: pageSize,
      query: this.query,
      sort: [
        // 根据发布时间倒排,再按创建时间(同_id)倒排
        { publishDate: { order: 'desc' } },
        { _id: { order: 'desc' } }
      ],
      _source: {
        includes: [
          'title',
          'articleId',
          'siteId',
          'cover',
          'url',
          'pathName',
          'publishDate',
          'attachmentUrl',
          'districtName',
          'gpCatalogName',
          'author',
          'remark',
          'invalid',
          'invalidDate'
        ],
        excludes: ['content']
      }
    };
    // 关键字存在时按相关度排序
    keyword && obj.sort.unshift({ _score: { order: 'desc' } });
    return this.search(obj);
  }

  // 用于文章详情的获取
  getArticle ({ siteId = this.siteId, keyword, code }) {
    this.resetQuery();
    this.buildTermQuery('siteId', siteId);
    keyword && this.buildMatchQuery('title', keyword);
    code && this.buildWildcardQuery('path', `*6${code.toLowerCase()}6*`);
    const obj = {
      from: 0,
      size: 1,
      query: this.query,
      sort: [
        // 根据发布时间倒排,再按创建时间(同_id)倒排
        { publishDate: { order: 'desc' } },
        { _id: { order: 'desc' } }
      ],
      _source: {
        includes: ['publishDate', 'content']
      }
    };
    return this.search(obj);
  }

  // 用于公开信箱列表获取
  searchMailList ({
    siteId = this.siteId,
    pageNo,
    pageSize,
    keyword,
    begin,
    end,
    type
  }) {
    this.resetQuery();
    this.buildTermQuery('siteId', siteId);
    // keyword && this.buildSimpleWildcardQuery('title', `*${keyword}*`);
    keyword && this.buildSimpleWildcardQuery('title', keyword);
    begin && end && this.buildRangeQuery('replyDate', begin, end);
    if (type !== null && type !== undefined && type !== '') {
      this.buildTermQuery('type', type);
    }
    const obj = {
      from: (pageNo - 1) * pageSize,
      size: pageSize,
      query: this.query,
      sort: [
        // 根据发布时间倒排,再按创建时间(同_id)倒排
        { replyDate: { order: 'desc' } }
      ],
      _source: {
        includes: ['title', 'pathName', 'replyDate', 'id', 'type'],
        excludes: ['content']
      }
    };
    // includes里面是返回参数内容，短路表达式
    // 关键字存在时按相关度排序
    keyword && obj.sort.unshift({ _score: { order: 'desc' } });
    return this.searchMail(obj);
  }

  // 用于二级页的搜索
  searchAnnoucement ({ siteId = this.siteId, pageNo = 1, pageSize, code = 'ZcyAnnouncement', begin, end }) {
    this.resetQuery();
    this.buildTermQuery('siteId', siteId);
    begin && end && this.buildRangeQuery('bidOpeningTime', begin, end);
    code && this.buildWildcardQuery('path', `*6${code.toLowerCase()}6*`);
    const obj = {
      from: (pageNo - 1) * pageSize,
      size: pageSize,
      query: this.query,
      sort: [{ _id: { order: 'desc' } }],
      _source: {
        // includes: ['title', 'articleId', 'siteId', 'pathName', 'replyDate', 'id', 'type'],
        excludes: ['content']
      }
    };
    // 关键字存在时按相关度排序
    return this.search(obj);
  }

  search (payload) {
    return Server.queryES(payload);
  }

  searchMail (payload) {
    return Server.queryMailList(payload);
  }
}

module.exports = EsClient;
